import { produce } from 'immer';
import type { AnyAction } from 'redux';
import { GET_ACTIVE_QUESTIONNAIRES_SUCCESS } from '../../constants/actions/users.constants';
import { LOGOUT } from '../../constants/actions/auth.constants';
import QuestionnaireActions from '../../participant/actions/QuestionnaireActions';

export default function (
    state: { id: number }[] | null = null,
    action: AnyAction,
) {
    switch (action.type) {
        case GET_ACTIVE_QUESTIONNAIRES_SUCCESS:
            return action.payload;
        case QuestionnaireActions.closeQuestionnaire.type:
            if (state !== null) {
                const index = state.findIndex(
                    (item) => item.id === action.payload?.id,
                );

                if (index >= 0) {
                    return produce(state, (draft) => {
                        draft.splice(index, 1);
                    });
                }
            }

            return state;
        case LOGOUT:
            return null;
        default:
            return state;
    }
}
